import { Navigate, useSearchParams } from "react-router";
import { ROLE_LABELS } from "@klantpunt/shared";
import { Logo } from "../app/Logo";
import { useSwitchOrg } from "../app/useSwitchOrg";
import { useMe } from "../lib/auth";

export function ChooseOrgPage() {
  const { data: me, isPending } = useMe();
  const [params] = useSearchParams();
  const terug =
    params.get("terug")?.startsWith("/") && !params.get("terug")?.startsWith("//") ? params.get("terug")! : "/";
  const switchOrg = useSwitchOrg();

  if (isPending) return null;
  if (!me) return <Navigate to="/inloggen" replace />;

  const choose = (orgId: string) => switchOrg(orgId, terug);

  return (
    <div className="login">
      <div className="card">
        <Logo />
        <h1 className="dot">Kies organisatie</h1>
        {me.orgs.length === 0 ? (
          <p className="muted">Je bent (nog) geen lid van een organisatie.</p>
        ) : (
          <ul className="list">
            {me.orgs.map((o) => (
              <li key={o.id}>
                <span className="grow">
                  <strong>{o.name}</strong>
                  <br />
                  <span className="muted">{ROLE_LABELS[o.role]}</span>
                </span>
                <button type="button" className="btn primary small" onClick={() => choose(o.id)}>
                  {me.org?.id === o.id ? "Huidige" : "Kies"}
                </button>
              </li>
            ))}
          </ul>
        )}
      </div>
    </div>
  );
}
